<div class="brand-header bg-lw-green">
  <div class="brand-header__row px-4 max-w-3xl mx-auto text-white">
    <div class="flex justify-between flex-nowrap items-center">
      <div class="brand-header__col">
        <img class="brand-header__logo max-h-28" [src]="brandLogo">
      </div> 

      <div class="brand-header__col text-xl font-medium" [innerHTML]="dynamicPhoneNumber">
      </div>
    </div>
  </div>
</div>
   